import axios from 'axios';
import Cookies from "js-cookie";
import BankHubLog from "./config/BankHubLog";

axios.interceptors.request.use(request => {
    request.headers = {
        'content-type': 'application/json',
        'X-XSRF-TOKEN': Cookies.get('token') || ''
    }

    request.withCredentials = true
    request.baseURL = request.baseURL || process.env.REACT_APP_BASE_URL;
    return request;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(
    response => {
        if(response.status === 200) {
            if(response.headers['x-csrf-token']) {
                Cookies.set('token', response.headers['x-csrf-token'], {path: '/', expires: 12000000, secure: true, sameSite: 'none'})
            }
            if(response.data && response.data.code && BankHubLog[response.data.code]) {
                var msg = BankHubLog[response.data.code]
                if(response.data.additionalInfo) {
                    msg = msg.replace("VARIABLE_VALUE", response.data.additionalInfo)
                }
                document.getElementById("popup-alert-bankhub")
                    .classList.remove("hide")
                document.getElementById("popup-alert-bankhub")
                    .classList.add('show')
                document.getElementById("popup-alert-bankhub-text").innerHTML = msg
            }
        }
        return response
    },
    error => {
        // if (error.response.status === 401) {
        //     console.log('err')
        // }
        if(error.response && error.response.data && error.response.data.code) {
            var msg = BankHubLog[error.response.data.code]
            document.getElementById("popup-alert-bankhub")
                .classList.remove("hide")
            document.getElementById("popup-alert-bankhub")
                .classList.add('show')
            document.getElementById("popup-alert-bankhub-text").innerHTML = msg
        }
        return Promise.reject(error);
    },
);

export default axios;
